<style lang="sass">
@import ~bi/utilities
@import ~bi/brand/variables
@import ../../assets/sass/m3_variables
@import sass/contact
</style>

<template>
    <div class="g_contactButtons">
        <Cta
            v-if="$json.menu.phone.link"
            type="text"
            class="g_btn g_btnBuy g_phone"
            :link="$json.menu.phone.link"
            target="_self"
            fontIcon="fn_phone"
            :content="$json.menu.phone.cta" />
        <Cta
            v-if="$json.menu.courriel.link"
            type="text"
            class="g_btn g_btnBuy g_contact"
            :link="$json.menu.courriel.link"
            target="_self"
            fontIcon="fn_email"
            :content="$json.menu.courriel.cta" />
    </div>
</template>

<script>

export default {
    name: 'Contact'
}
</script>
